import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-05/lesson-18/task-02";

const task: Slide = {
  title: "Indicate which measures will yield good airborne sound insulation of a double-leaf wall.",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
